import logger from "../../common/logger"
import "../../lib/get-stats"
import SoundMeter from "../../lib/sound-meter"

/**
 * 媒体数据统计
 */
class MediaStats {
  constructor() {
    this.gettingPcStats = false
    this.gettingAudioStats = false
    this.soundMeter = new SoundMeter(new AudioContext())
    this.isRecv = true
    this.stats = {
      audio: { totalBytes: 0, bitRate: 0, volume: 0, slow: 0 },
      video: { totalBytes: 0, bitRate: 0, frameRate: 0, width: 0, height: 0 }
    }

    this.volumeIntervalHandle = null
  }

  /**
   * 开始PeerConnection统计
   * @param {*} pc 
   * @param {*} isRecv 
   */
  startPcStats(pc, isRecv) {
    if (this.gettingPcStats) {
      console.warn("Already getting peer connection stats!")
      return
    }

    if (!pc) {
      logger.error("Invalid peer connection")
      return
    }

    try {
      getStats(pc, this._statsCallback.bind(this), 1000)
      this.gettingPcStats = true
      this.isRecv = isRecv
    } catch(err) {
      logger.error("getStats failed!" + err)
    }
  }

  /**
   * 停止PeerConnection统计
   */
  stopPcStats() {
    this.gettingPcStats = false
  }

  /**
   * 开始音量统计
   * @param {*} stream 
   */
  startAudioStats(stream) {
    this._doGetSoundMeter(stream);
  }

  /**
   * 停止音量统计
   */
  stopAudioStats() {
    clearInterval(this.volumeIntervalHandle)
  }

  /**
   * 关闭
   */
  stopMediaStats() {
    this.stopAudioStats()
    this.stopPcStats()
    if (this.soundMeter) {
      this.soundMeter.stop()
      this.soundMeter = null
    }
  }

  /**
   * 接收统计
   * @param {*} stats 
   */
  _processRecvStats(stats) {
    try {
      this.stats.audio.bitRate = 
        parseInt((stats.audio.bytesReceived - this.stats.audio.totalBytes) * 8 / 1000);
      
        this.stats.audio.totalBytes = stats.audio.bytesReceived;

      this.stats.video.bitRate = 
        parseInt((stats.video.bytesReceived - this.stats.video.totalBytes) * 8 / 1000);
      
      this.stats.video.totalBytes = stats.video.bytesReceived;

      this.stats.video.frameRate = 0;
      for (const result of stats.results) {
        if (result.googFrameRateReceived && result.googFrameRateReceived != '0') {
          this.stats.video.frameRate = result.googFrameRateReceived;
          break;    
        }
      }
      
      this.stats.video.width = stats.resolutions.recv.width;
      this.stats.video.height = stats.resolutions.recv.height;
    } catch (err) {
      logger.error(err);
    }
  }

  /**
   * 发送统计
   * @param {*} stats 
   */
  _processSendStats(stats) {
    try {
      this.stats.audio.bitRate = 
        parseInt((stats.audio.bytesSent - this.stats.audio.totalBytes) * 8 / 1000)

      this.stats.audio.totalBytes = stats.audio.bytesSent

      this.stats.video.bitRate = 
        parseInt((stats.video.bytesSent - this.stats.video.totalBytes) * 8 / 1000)

      this.stats.video.totalBytes = stats.video.bytesSent
      
      this.stats.video.frameRate = 0
      for (const result of stats.results) {
        if (result.googFrameRateSent) {
          this.stats.video.frameRate = result.googFrameRateSent  
        }
      }
      
      this.stats.video.width = stats.resolutions.send.width
      this.stats.video.height = stats.resolutions.send.height
    } catch (err) {
      logger.error(err)
    }
  }

  /**
   * getStats回调
   * @param {*} stats 
   */
  _statsCallback(stats) {
    if (this.isRecv) {
      this._processRecvStats(stats)
    } else {
      this._processSendStats(stats)
    }

    // 返回true停止计时器
    return (!this.gettingPcStats) 
  }

  /**
   * 获取音量
   * @param {*} stream 
   */
  _doGetSoundMeter(stream) {
    if (!this.soundMeter) return
    let self = this
    // let ctx = new AudioContext()
    // let meter = volumeMeter(ctx, (volume) => {
    //   this.stats.audio.volume = volume
    // })
    // var src = ctx.createMediaStreamSource(stream)
    // src.connect(meter)
    // src.connect(ctx.destination)
    // stream.onended = meter.stop.bind(meter)

    try {
      this.soundMeter.connectToSource(stream, function(e) {
        if (e) {
          setTimeout(function() {
            self._doGetSoundMeter(stream)
          }, 1000)
        } else {
          self.volumeIntervalHandle = setInterval(()=>{
            if (self.soundMeter) {
              self.stats.audio.volume = self.soundMeter.instant.toFixed(2)
              self.stats.audio.slow = self.soundMeter.slow.toFixed(2)
            }
          }, 100)
        }
      })
    } catch(err) {
      console.error(err)
    }
  }
}

export default MediaStats